import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";

const DistributeStockModal = ({
  show,
  onClose,
  product,
  caisses,
  mainStock,
  caisseStocks,
  onSubmit,
}) => {
  const { t } = useTranslation();
  console.log(caisses)
  const [distributions, setDistributions] = useState(
    caisses.map((caisse) => ({
      caisseId: caisse.id,
      caisseName: caisse.nom,
      quantity: 0,
      currentStock:
        caisseStocks[caisse.id]?.find((s) => s.product_id === product._id)
          ?.quantite_stock || 0,
    })),
  );

  const totalDistributed = distributions.reduce(
    (sum, d) => sum + (parseInt(d.quantity) || 0),
    0,
  );
  const remainingStock = mainStock - totalDistributed;

  const handleQuantityChange = (index, value) => {
    const newDistributions = [...distributions];
    newDistributions[index].quantity = parseInt(value) || 0;
    setDistributions(newDistributions);
  };

  const handleSubmit = () => {
    const distributionData = {
      productId: product._id,
      distributions: distributions
        .filter((d) => d.quantity > 0)
        .map((d) => ({
          caisseId: d.caisseId,
          quantity: d.quantity,
        })),
    };
    console.log(distributionData)
    onSubmit(distributionData);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {t("Distribuer le stock")} - {product.titre?.fr || product.titre}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info">
          <strong>{t("Stock disponible")}:</strong> {mainStock} unités
          <br />
          <strong>{t("Total à distribuer")}:</strong> {totalDistributed} unités
          <br />
          <strong>{t("Reste en stock principal")}:</strong> {remainingStock}{" "}
          unités
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{t("Caisse")}</th>
              <th>{t("Stock actuel")}</th>
              <th>{t("Quantité à distribuer")}</th>
              <th>{t("Nouveau stock")}</th>
            </tr>
          </thead>
          <tbody>
            {distributions.map((dist, index) => (
              <tr key={dist.caisseId}>
                <td>{dist.caisseName}</td>
                <td>{dist.currentStock}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    min="0"
                    max={remainingStock + dist.quantity}
                    value={dist.quantity}
                    onChange={(e) =>
                      handleQuantityChange(index, e.target.value)
                    }
                  />
                </td>
                <td>{dist.currentStock + (parseInt(dist.quantity) || 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("Annuler")}
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={totalDistributed === 0 || totalDistributed > mainStock}
        >
          {t("Distribuer")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DistributeStockModal;
